export default __webpack_public_path__ + "static/COSO-ICSR-Report-f43139fa25367eecc1521490cbee598d.pdf";